import React from 'react';
import Navbar from './Navbar';
import { AdminSidebar } from './Sidebar';
import { SidebarProvider, SidebarInset } from './ui/sidebar';

const Layout = ({ children }) => {
  return (
    <SidebarProvider defaultOpen={true}>
      <AdminSidebar />
      <SidebarInset className="bg-background min-h-screen flex flex-col min-w-0 overflow-hidden">
        <Navbar />
        <main className="flex-1">
          <div className="mx-auto max-w-[1440px] px-5 py-6 sm:px-8 sm:py-8 md:px-10 md:py-10">
            {children}
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default Layout;
